import React, { useState } from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import ShareIconButton from '../ShareIconButton';
import { system900, system300 } from 'Mui/styles/color';

const CopyShareButton = ({
    url = '',
    color = system900.color,
    variant = 'contained',
    isFetchingData
}) => {
    const [, copy] = useCopyToClipboard();
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = async event => {
        event.persist();
        const isCopySuccess = await copy(url);
        if (isCopySuccess) {
            setAnchorEl(event.currentTarget || event.target);
        }
    };
    const open = Boolean(anchorEl);
    function handleClose() {
        setAnchorEl(null);
    }
    return (
        <>
            <ShareIconButton
                variant={variant}
                text={i18n.t('btn.copy')}
                textColor={color}
                bgColor="#ffffff"
                imageUrl="https://assets.fevercdn.com/promotion/img/content_copy.svg"
                size={24}
                onClick={handleClick}
                style={copyButtonStyle(variant)}
                isFetchingData={isFetchingData}
            />
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                style={{
                    transform: 'translateY(-16px)'
                }}
            >
                <Typography style={{ padding: '8px 16px' }}>{i18n.t('label.share_url')}</Typography>
            </Popover>
        </>
    );
};

export default CopyShareButton;

CopyShareButton.propTypes = {
    url: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string
};

const copyButtonStyle = variant => css`
    position: 'relative';
    color: ${system300.color};
    border-color: ${variant === 'outlined' ? system300.color : ''};
`;
